import { releaseTickets } from 'api/ticket'
import { ActionButton } from 'components/button/button.styled'
import { LoadingContainer } from 'components/loadingContainer'
import { PlaceholderContainer } from 'components/placeholder'
import { SeatReleaseSelector } from 'components/seatReleaseSelector'
import { ShowEventSelector } from 'components/showEventSelector'
import { Container, PageTitle, PageTitleRow, ShowTitle, TitleBox } from 'components/ticket/ticket.style'
import { useConfirmDialog } from 'hooks/admin/useConfirmDialog'
import { useEventsAdmin } from 'hooks/admin/useEvents'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { EventDetails } from 'types/Event'
import { removeSelectedTicketsForReleaseFromStorage } from 'utils/sessionStorage'

interface Props {
    currentEvent: EventDetails
}

export const LocalRelease = ({ currentEvent }: Props) => {
    const { data: events, isLoading, error } = useEventsAdmin()
    const [isComplimentary, setIsComplimentary] = useState(false)
    const { show: showConfirmDialog, DialogComponent: ConfirmDialog } = useConfirmDialog()
    const navigate = useNavigate()

    const navigateToSell = () => {
        navigate(`/admin/jegyek/eladas/${currentEvent.event_id}`)
    }

    const releaseTicketsHandler = (seatIds: string[]) => {
        releaseTickets(currentEvent.event_id, seatIds).then(() => {
            removeSelectedTicketsForReleaseFromStorage(currentEvent.event_id)
            window.location.reload()
        })
    }

    return (
        <Container>
            <PageTitleRow>
                <PageTitle>Hely felszabadítása</PageTitle>
                <ActionButton onClick={navigateToSell}>Jegyértékesítés</ActionButton>
            </PageTitleRow>
            <TitleBox>
                <ShowTitle>{currentEvent.show.name}</ShowTitle>
            </TitleBox>
            <LoadingContainer isLoading={isLoading} error={error}>
                {events && (
                    <ShowEventSelector
                        currentEvent={currentEvent}
                        events={events}
                        title="Kiválasztott előadás"
                        redirectUrl="/admin/jegyek/eladas"
                    />
                )}
            </LoadingContainer>
            {currentEvent.location.auditorium ? (
                <>
                    <SeatReleaseSelector
                        currentEvent={currentEvent}
                        actionLabel={'Helyek felszabadítása'}
                        actionHandler={(seatIds: string[]) => {
                            showConfirmDialog(
                                () => releaseTicketsHandler(seatIds),
                                'Figyelmeztetés',
                                'A kiválasztott helyek felszabadításra kerülnek, és újra értékesíthetővé válnak. Biztosan folytatni szeretné?',
                            )
                        }}
                        isComplimentary={isComplimentary}
                        setIsComplimentary={setIsComplimentary}
                    />
                    <ConfirmDialog />
                </>
            ) : (
                <PlaceholderContainer>
                    <p>A jegy felszabadítás jelenleg nem elérhető ehhez az eseményhez.</p>
                </PlaceholderContainer>
            )}
        </Container>
    )
}

// add local selling flag to tickets !
